
import { defineComponent } from 'vue';
import SvgLocation from '@/components/Icons/SvgLocation.vue';
import SvgCamera from '@/components/Icons/SvgCamera.vue';
import SvgXMark from '@/components/Icons/SvgXMark.vue';
import ArrowIcon from '@/components/Icons/ArrowIcon.vue';
import AndroidIcon from '@/components/Icons/AndroidIcon.vue';
import ZonarIcon from '@/components/Icons/ZonarIcon.vue';
import VerticalEllipses from '@/components/Icons/VerticalEllipses.vue';
import ChromeSettingsIcon from '@/components/Icons/ChromeSettingsIcon.vue';
import useUserAgentDetails from '@/shared/composables/useUserAgentDetails';
import { PermissionsMessagingTypes } from '@/types/UserAgentDetails';
import FbxButton from '@/components/fbx-button.vue';
import { MutationTypes } from '@/store/mutationTypes';

const userFacingOSMap: {
    [Type in PermissionsMessagingTypes]: string;
} = {
    [PermissionsMessagingTypes.ANDROID_IN_BROWSER]: 'my browser on an Android',
    [PermissionsMessagingTypes.ANDROID_IN_PWA]: 'my Zonar tablet',
    [PermissionsMessagingTypes.IOS_CHROME]: 'iOS Chrome',
    [PermissionsMessagingTypes.IOS_SAFARI]: 'iOS Safari',
    [PermissionsMessagingTypes.DEFAULT]: 'default',
};

export default defineComponent({
    data(): {
        messagingType: PermissionsMessagingTypes;
    } {
        return {
            messagingType: PermissionsMessagingTypes.DEFAULT,
        };
    },
    components: {
        ArrowIcon,
        AndroidIcon,
        FbxButton,
        SvgCamera,
        SvgLocation,
        SvgXMark,
        VerticalEllipses,
        ZonarIcon,
        ChromeSettingsIcon,
    },
    props: {},
    setup() {
        const { getSystemMessagingType } = useUserAgentDetails();
        return { getSystemMessagingType };
    },
    created() {
        this.setMessaging();
    },
    computed: {
        isDefaultView(): boolean {
            return this.messagingType === PermissionsMessagingTypes.DEFAULT;
        },
        showAndroidInBrowser(): boolean {
            return (
                this.messagingType ===
                PermissionsMessagingTypes.ANDROID_IN_BROWSER
            );
        },
        showAndroidInPwa(): boolean {
            return (
                this.messagingType === PermissionsMessagingTypes.ANDROID_IN_PWA
            );
        },
        showIOSinChrome(): boolean {
            return this.messagingType === PermissionsMessagingTypes.IOS_CHROME;
        },
        showIOSinSafari(): boolean {
            return this.messagingType === PermissionsMessagingTypes.IOS_SAFARI;
        },
        incorrectOSText(): string {
            return `I’m not using ${userFacingOSMap[this.messagingType]}`;
        },
        rootDriverURL(): string {
            return window.location.hostname;
        },
    },
    methods: {
        dismissGuide(): void {
            this.$store.commit(
                MutationTypes.SET_PERMISSIONS_STEPS_GUIDE_SHOWN,
                false
            );
        },
        setMessaging(messagingType?: PermissionsMessagingTypes | undefined) {
            if (messagingType !== undefined) {
                this.messagingType = messagingType;
            } else {
                this.messagingType = this.getSystemMessagingType();
            }
        },
    },
});
